import { IonButton } from "@ionic/react";
import { useEffect } from "react";

interface Props {
  setCalibratingLoader: Function;
}
const CalibratingLoaderModal: React.FC<Props> = ({ setCalibratingLoader }) => {
  useEffect(() => {
    setCalibratingLoader("CalibratingLoader");
  }, []);

  return (
    <>
      <div className="calibrating-loader">
        <div className="ion-hide">
          <p className="calibrating-text">Calibrating...</p>
          <div className="loader"></div>
        </div>
        <div className="">
          <div className="d-flex flex-column align-items-center ">
            <p className="calibrating-text m-20">Calibration</p>
            <p className="calibrating-text"> Complete!</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="154"
              height="154"
              viewBox="0 0 154 154"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M76.9993 0.727783C34.8752 0.727783 0.726929 34.8761 0.726929 77.0002C0.726929 119.124 34.8752 153.273 76.9993 153.273C119.123 153.273 153.272 119.124 153.272 77.0002C153.272 34.8761 119.123 0.727783 76.9993 0.727783Z"
                fill="#0F854C"
              />
              <path
                d="M99.8811 61.7461L69.3722 92.2551L54.1177 77.0006"
                stroke="white"
                strokeWidth="15.2545"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="take-seat">Take a seat to begin assessment.</p>
          </div>
        </div>

        <div className="ion-hide">
          <p className="calibrating-text">Go!</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="279"
            height="279"
            viewBox="0 0 279 279"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M139.499 0.50293C62.7336 0.50293 0.502747 62.7337 0.502747 139.499C0.502747 216.265 62.7336 278.496 139.499 278.496C216.265 278.496 278.496 216.265 278.496 139.499C278.496 62.7337 216.265 0.50293 139.499 0.50293Z"
              fill="#0F854C"
            />
            <path
              d="M181.198 111.701L125.6 167.3L97.8003 139.5"
              stroke="white"
              strokeWidth="27.7993"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};
export default CalibratingLoaderModal;
